"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchCreditNotePresentationQuery = exports.useApproveCreditNotesMutation = exports.useFetchCreditNotesQuery = exports.useRemoveCreditNotePdfMutation = exports.useLazyFetchCreditNotePdfUrlQuery = exports.useUploadCreditNotePdfMutation = exports.useCreateCreditNotesMutation = exports.creditNoteApi = void 0;
// api/creditNoteApi.ts — IF-004.3.2: create credit notes, attach/view/remove their PDFs, and read them.
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.creditNoteApi = (0, react_1.createApi)({
    reducerPath: "creditNoteApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["creditNotes"],
    endpoints: function (builder) { return ({
        createCreditNotes: builder.mutation({
            query: function (body) { return ({ url: "/v1/credit-note/create", method: "POST", body: body }); },
            invalidatesTags: ["creditNotes"],
        }),
        // Multipart PDF upload. A dedup clash comes back as a 409 with `{ message, clash }` in error.data.
        uploadCreditNotePdf: builder.mutation({
            query: function (_a) {
                var creditNoteId = _a.creditNoteId, formData = _a.formData;
                return ({ url: "/v1/credit-note/".concat(creditNoteId, "/attachment"), method: "POST", body: formData });
            },
            invalidatesTags: ["creditNotes"],
        }),
        fetchCreditNotePdfUrl: builder.query({
            query: function (creditNoteId) { return ({ url: "/v1/credit-note/".concat(creditNoteId, "/attachment/url"), method: "GET" }); },
        }),
        removeCreditNotePdf: builder.mutation({
            query: function (_a) {
                var creditNoteId = _a.creditNoteId, performedBy = _a.performedBy;
                return ({ url: "/v1/credit-note/".concat(creditNoteId, "/attachment"), method: "DELETE", body: { performedBy: performedBy } });
            },
            invalidatesTags: ["creditNotes"],
        }),
        fetchCreditNotes: builder.query({
            query: function (params) { return ({ url: "/v1/credit-note/all", method: "GET", params: params }); },
            providesTags: ["creditNotes"],
        }),
        // IF-004.4: grouped, display-ready credit-noted/rebilled/rebillable charges for the Invoice-view overlay.
        fetchCreditNotePresentation: builder.query({
            query: function (params) { return ({ url: "/v1/credit-note/presentation", method: "GET", params: params }); },
            providesTags: ["creditNotes"],
        }),
        // Approve — applies the four re-invoicing toggles. A missing-PDF block comes back as 409
        // with `{ message, missingPdf }` in error.data.
        approveCreditNotes: builder.mutation({
            query: function (body) { return ({ url: "/v1/credit-note/approve", method: "POST", body: body }); },
            invalidatesTags: ["creditNotes"],
        }),
    }); },
});
exports.useCreateCreditNotesMutation = exports.creditNoteApi.useCreateCreditNotesMutation, exports.useUploadCreditNotePdfMutation = exports.creditNoteApi.useUploadCreditNotePdfMutation, exports.useLazyFetchCreditNotePdfUrlQuery = exports.creditNoteApi.useLazyFetchCreditNotePdfUrlQuery, exports.useRemoveCreditNotePdfMutation = exports.creditNoteApi.useRemoveCreditNotePdfMutation, exports.useFetchCreditNotesQuery = exports.creditNoteApi.useFetchCreditNotesQuery, exports.useApproveCreditNotesMutation = exports.creditNoteApi.useApproveCreditNotesMutation, exports.useFetchCreditNotePresentationQuery = exports.creditNoteApi.useFetchCreditNotePresentationQuery;
